import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654e013a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "header-search-form_inputs-group c-autocomplete" }
const _hoisted_17 = {
  class: "header-search-form_input header-search-form_input-job",
  "data-focus-field": "",
  "data-js": "m-input"
}
const _hoisted_18 = { class: "header-search-form_label" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  class: "header-search-form_input header-search-form_input-location c-autocomplete",
  "data-focus-field": "",
  "data-js": "m-input"
}
const _hoisted_21 = { class: "c-algolia-autocomplete" }
const _hoisted_22 = { class: "header-search-form_label" }
const _hoisted_23 = ["disabled"]

import {ref, onMounted} from 'vue';
    import omit from 'lodash/omit';
    import {Address, useLocationAutocomplete, useSearchForm} from '../composables';
    import {storeToRefs} from 'pinia';
    import {useHeaderMenu} from '../header-menu.store';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSearchForm',
  setup(__props) {

    const headerMenuStore = useHeaderMenu();
    const {searchPreviewTarget} = storeToRefs(headerMenuStore);

    const headerSearchForm = ref<HTMLFormElement | null>(null);
    const jobInput = ref<HTMLInputElement | null>(null);
    const locationInput = ref<HTMLInputElement | null>(null);

    const searchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(searchParams);

    const {hiddenInputs, v$, form, onJobSelect, onSubmit} = useSearchForm(params);

    function onLocationSelect(selectedAddress: Address) {
        form.locationQuery = selectedAddress.formattedAddress!;
        hiddenInputs.value = {
            ...omit(selectedAddress, 'loc'),
            lat: selectedAddress.loc?.lat,
            lon: selectedAddress.loc?.lon,
        };
    }
    useLocationAutocomplete(params, locationInput, onLocationSelect);

    function setFocusOnInput(input: HTMLInputElement) {
        setTimeout(() => {
            input.focus();
        });
    }

    onMounted(() => {
        if (!params.location) {
            locationInput.value!.value = '';
        }

        if (searchPreviewTarget.value === 'JOB') {
            setFocusOnInput(jobInput.value!);
        } else if (searchPreviewTarget.value === 'LOCATION') {
            setFocusOnInput(locationInput.value!);
        }
        Hop.events.on('navbar:searchResetRequested', () => {
            hiddenInputs.value = {};
            Hop.events.trigger('navbar:searchRequested', {
                reset: true,
                payload: {q: form.jobQuery, location: form.locationQuery},
            });
        });
    });

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!
  const _component_joy_button = _resolveComponent("joy-button")!

  return (_openBlock(), _createElementBlock("form", {
    id: "headerSearchV2",
    ref_key: "headerSearchForm",
    ref: headerSearchForm,
    action: "/s",
    tabindex: "-1",
    class: "header-search-form",
    "data-form": "search",
    novalidate: "",
    onSubmit: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
  }, [
    _withDirectives(_createElementVNode("input", {
      id: "search_lon",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(hiddenInputs).lon) = $event)),
      name: "lon",
      type: "hidden",
      disabled: !_unref(hiddenInputs).lon
    }, null, 8, _hoisted_1), [
      [_vModelText, _unref(hiddenInputs).lon]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_lat",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(hiddenInputs).lat) = $event)),
      name: "lat",
      type: "hidden",
      disabled: !_unref(hiddenInputs).lat
    }, null, 8, _hoisted_2), [
      [_vModelText, _unref(hiddenInputs).lat]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_countryCode",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(hiddenInputs).countryCode) = $event)),
      name: "countryCode",
      type: "hidden",
      disabled: !_unref(hiddenInputs).countryCode
    }, null, 8, _hoisted_3), [
      [_vModelText, _unref(hiddenInputs).countryCode]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_country",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(hiddenInputs).country) = $event)),
      name: "country",
      type: "hidden",
      disabled: !_unref(hiddenInputs).country
    }, null, 8, _hoisted_4), [
      [_vModelText, _unref(hiddenInputs).country]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_administrativeAreaLevel1",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(hiddenInputs).administrativeAreaLevel1) = $event)),
      name: "administrativeAreaLevel1",
      type: "hidden",
      disabled: !_unref(hiddenInputs).administrativeAreaLevel1
    }, null, 8, _hoisted_5), [
      [_vModelText, _unref(hiddenInputs).administrativeAreaLevel1]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_administrativeAreaLevel1Code",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(hiddenInputs).administrativeAreaLevel1Code) = $event)),
      name: "administrativeAreaLevel1Code",
      type: "hidden",
      disabled: !_unref(hiddenInputs).administrativeAreaLevel1Code
    }, null, 8, _hoisted_6), [
      [_vModelText, _unref(hiddenInputs).administrativeAreaLevel1Code]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_administrativeAreaLevel2",
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(hiddenInputs).administrativeAreaLevel2) = $event)),
      name: "administrativeAreaLevel2",
      type: "hidden",
      disabled: !_unref(hiddenInputs).administrativeAreaLevel2
    }, null, 8, _hoisted_7), [
      [_vModelText, _unref(hiddenInputs).administrativeAreaLevel2]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_administrativeAreaLevel2Code",
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(hiddenInputs).administrativeAreaLevel2Code) = $event)),
      name: "administrativeAreaLevel2Code",
      type: "hidden",
      disabled: !_unref(hiddenInputs).administrativeAreaLevel2Code
    }, null, 8, _hoisted_8), [
      [_vModelText, _unref(hiddenInputs).administrativeAreaLevel2Code]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_administrativeAreaLevel3",
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(hiddenInputs).administrativeAreaLevel3) = $event)),
      name: "administrativeAreaLevel3",
      type: "hidden",
      disabled: !_unref(hiddenInputs).administrativeAreaLevel3
    }, null, 8, _hoisted_9), [
      [_vModelText, _unref(hiddenInputs).administrativeAreaLevel3]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_administrativeAreaLevel3Code",
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(hiddenInputs).administrativeAreaLevel3Code) = $event)),
      name: "administrativeAreaLevel3Code",
      type: "hidden",
      disabled: !_unref(hiddenInputs).administrativeAreaLevel3Code
    }, null, 8, _hoisted_10), [
      [_vModelText, _unref(hiddenInputs).administrativeAreaLevel3Code]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_administrativeAreaLevel4",
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(hiddenInputs).administrativeAreaLevel4) = $event)),
      name: "administrativeAreaLevel4",
      type: "hidden",
      disabled: !_unref(hiddenInputs).administrativeAreaLevel4
    }, null, 8, _hoisted_11), [
      [_vModelText, _unref(hiddenInputs).administrativeAreaLevel4]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_administrativeAreaLevel4Code",
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(hiddenInputs).administrativeAreaLevel4Code) = $event)),
      name: "administrativeAreaLevel4Code",
      type: "hidden",
      disabled: !_unref(hiddenInputs).administrativeAreaLevel4Code
    }, null, 8, _hoisted_12), [
      [_vModelText, _unref(hiddenInputs).administrativeAreaLevel4Code]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "search_city",
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(hiddenInputs).city) = $event)),
      name: "city",
      type: "hidden",
      disabled: !_unref(hiddenInputs).city
    }, null, 8, _hoisted_13), [
      [_vModelText, _unref(hiddenInputs).city]
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(hiddenInputs).remoteAllowed) = $event)),
      name: "remoteAllowed",
      type: "hidden",
      disabled: !_unref(hiddenInputs).remoteAllowed
    }, null, 8, _hoisted_14), [
      [_vModelText, _unref(hiddenInputs).remoteAllowed]
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(hiddenInputs).remoteEuropa) = $event)),
      name: "remoteEuropa",
      type: "hidden",
      disabled: !_unref(hiddenInputs).remoteEuropa
    }, null, 8, _hoisted_15), [
      [_vModelText, _unref(hiddenInputs).remoteEuropa]
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("label", null, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$msg('navbar.header.search.form.job.label')), 1),
          _withDirectives(_createElementVNode("input", {
            id: "header_search-form__job-input",
            ref_key: "jobInput",
            ref: jobInput,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).jobQuery) = $event)),
            required: "",
            pattern: "^.{3,}$",
            "data-awesomplete-input": "",
            "data-testid": "header_search-form__job-input",
            "data-heap": "navbar-logged__search-job--input",
            type: "text",
            placeholder: _ctx.$msg('navbar.header.search.form.job.placeholder'),
            name: "q",
            "data-jsobj": "[{'obj': 'autocomplete', 'option': {\n                            'suggestEndpoint': '/suggest/search?q=',\n                            'disablePicto': true,\n                            'onSelect': {'focus': '#header_search-form__location-input'},\n                            'minCharBeforeAutoCompletion': 2,\n                            'critical': true\n                        }}]",
            onAutofillInput: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_unref(onJobSelect) && _unref(onJobSelect)(...args)))
          }, null, 40, _hoisted_19), [
            [_vModelText, _unref(form).jobQuery]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("label", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$msg('navbar.header.search.form.location.label')), 1),
          _withDirectives(_createElementVNode("input", {
            id: "header_search-form__location-input",
            ref_key: "locationInput",
            ref: locationInput,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(form).locationQuery) = $event)),
            "data-testid": "header_search-form__location-input",
            type: "text",
            name: "location",
            "data-algolia-input": "",
            maxlength: "500",
            "data-heap": "navbar-logged__search-location--input",
            autocomplete: "off",
            onKeyup: _cache[18] || (_cache[18] = _withKeys(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _unref(form).locationQuery]
          ])
        ]),
        _createElementVNode("button", {
          class: "joy-btn joy-btn_main header-search-form_submit",
          type: "submit",
          "data-heap": "navbar-logged__search-submit",
          "data-testid": "header_search-form__submit",
          title: "Search",
          disabled: _unref(v$).$invalid
        }, [
          _createVNode(_component_joy_icon, {
            name: "search",
            color: "white",
            "aria-label": "Search"
          })
        ], 8, _hoisted_23)
      ])
    ]),
    _createVNode(_component_joy_button, {
      class: "header-search-form_submit--sm",
      variant: "main",
      type: "submit",
      disabled: _unref(v$).$invalid
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('navbar.header.search.form.submit.button')), 1)
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 544))
}
}

})